import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PhonesPhoto from '../../assets/images/Chat+Map.png'; // Update with your actual path

const Block5 = () => {
    return (
        <Box
            sx={{
                p: { xs: 4, sm: 15 },
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row-reverse' }} // Reverse row for text on the right
                alignItems="center"
                spacing={4}
                sx={{
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // Ensure proper wrapping for smaller screens
                }}
            >
                {/* Text Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: { xs: 'left', sm: 'left' }, // Center for mobile, left for desktop
                        maxWidth: { sm: '40%' },
                    }}
                >
                    {/* Phase 1 */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 500,
                            color: '#dc5454',
                            fontSize: { xs: '1.2rem', sm: '2rem' },
                            mb: 2,
                        }}
                    >
                        Our Vision
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "justify",
                            fontSize: { xs: '1rem', sm: '1.15rem' },
                            maxWidth: { xs: '100%', sm: '75%' },
                            mb: 4,
                        }}
                    >
                        An AI agent that works like a real travel agent — offering personalized trip
                        planning, smart bookings, and real-time support. From crafting your perfect
                        itinerary to rebooking your ride when your flight’s delayed, Travyx makes travel
                        effortless.
                    </Typography>

                </Box>

                {/* PNG Image */}
                <Box
                    component="img"
                    src={PhonesPhoto}
                    alt="Illustration"
                    draggable="false"
                    sx={{
                        flex: 1,
                        width: { xs: '100%', sm: '60%' }, // 85% width on mobile, 50% width on desktop
                        maxWidth: '620px',
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Block5;
